// extracted by mini-css-extract-plugin
module.exports = {"iframe":"IAgreePopup_iframe__1MtxH","card":"IAgreePopup_card__3LGeP","btn_Container":"IAgreePopup_btn_Container__3ciue"};